import { Stack, Alert, Text } from "@mantine/core";
import { Info } from "lucide-react";
import { UseFormReturnType } from "@mantine/form";
import { VariableConfig } from "./VariableConfig";

interface ReportVariablesConfigProps {
    form: UseFormReturnType<any>;
}

export function ReportVariablesConfig({ form }: ReportVariablesConfigProps) {
    const variables = form.values.variables || [];

    return (
        <Stack gap="md">
            <Alert icon={<Info size={16} />} title="Variables" color="gray" variant="light" radius="md">
                Variables detected in your SQL query (e.g. <code>{"{{variable_name}}"}</code>) will appear here.
                You can configure how they are presented to the user.
            </Alert>

            {variables.length === 0 ? (
                <Text c="dimmed" fs="italic" ta="center" py="xl">
                    No variables detected in query.
                </Text>
            ) : (
                variables.map((variable: any, index: number) => (
                    <VariableConfig
                        key={variable.name}
                        variable={variable}
                        onChange={(updated) => form.setFieldValue(`variables.${index}`, updated)}
                        onRemove={() => { }}
                    />
                ))
            )}
        </Stack>
    );
}
